import { Form, InputNumber, Button, Typography, Avatar, Select, Spin } from 'antd';
import SelectUser from '../../components/selectUser';
import SelectPlan from '../../components/selectPlan';
import ClassDetails from '../../components/scheduleCourtesy/classDetails';
import {
  CreditCardFilled,
  CrownOutlined,
  UserOutlined,
} from '@ant-design/icons';
import apiClient from '../../apis/ApiInterceptor';
import { openNotification } from '../../components/notifications';
import { useState } from 'react';
import PayTypes from '../../enums/pay_types';
import SelectCategory from '../../components/selectCategory';

const { Title } = Typography;
const { Option } = Select;

const CollectPayment = () => {
  const [form] = Form.useForm();
  const [payType, setPayType] = useState(null);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    values.amount_in_cents = values.amount * 100;
    values.amount = undefined;
    values.currency = 'COP';
    values.installments = 1;

    try {
      const response = await apiClient.post('/payments/collect', values);
      if (response.status === 200) {
        openNotification(
          "success",
          "",
          "Cobro realizado."
        );
        form.resetFields();
        setPayType(null);
      } else {
        console.log('Respuesta del servidor:', response.data);
        openNotification(
          "error",
          "",
          "Hubo un error al intentar hacer el cobro. Contacta a soporte."
        );
      }
    } catch (error) {
      console.error('Error al realizar el cobro:', error);
      openNotification(
        "error",
        "",
        "Hubo un error al intentar hacer el cobro. Contacta a soporte."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Title level={2} className='text-center mx-auto'>Collect Payment</Title>
      <Spin spinning={loading} tip="Procesando...">
        <Form
          form={form}
          name="validateOnly"
          className="mobile-block themed-block p-3"
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
        >
          {/* Required Inputs */}
          <div className="required-inputs">
            <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
              <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<UserOutlined />} />
              <div className="w-75">
                <Form.Item
                  name="user_id"
                  rules={[{ required: true, message: 'Por favor selecciona un usuario!' }]}
                >
                  <SelectUser />
                </Form.Item>
              </div>
            </div>
            <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
              <i className="fas fa-dollar-sign icons"></i>
              <div className="w-75">
                <Form.Item
                  name="amount"
                  rules={[{ required: true, message: 'Por favor ingresa el valor a cobrar!' }]}
                >
                  <InputNumber
                    className="w-100"
                    min={1000}
                    placeholder="Valor a cobrar"
                    formatter={value =>
                      value
                        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                        : ''
                    }
                    parser={value => value ? value.replace(/\./g, '') : ''}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
              <i className="fa fa-comments icons"></i>
              <div className="w-75">
                <Form.Item 
                  name="item_type" 
                  rules={[{ required: true, message: 'Por favor selecciona un tipo de pago!' }]}>
                  <Select
                    placeholder="Tipo de pago"
                    onChange={(value) => setPayType(value)}
                    allowClear
                  >
                    <Option value={PayTypes.PLAN}>Plan</Option>
                    {/*TODO: implement session <Option value={PayTypes.SESSION}>Sesión</Option>}*/}
                    <Option value={PayTypes.OTHER}>Otro</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
            {payType === PayTypes.PLAN && (
              <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                <Avatar size={28} style={{ backgroundColor: 'rgb(67, 5, 68)' }} icon={<CrownOutlined />} />
                <div className="w-75">
                  <Form.Item 
                    name="item_id"   
                    rules={[{ required: true, message: 'Por favor selecciona un plan!' }]}
                  >
                    <SelectPlan
                      onChange={(value) => form.setFieldsValue({ plan: value })}
                    />
                  </Form.Item>
                </div>
              </div>
            )}
            {payType === PayTypes.SESSION && (
              <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                <div className="w-75">
                   <Form.Item
                    name="classDetails"
                    rules={[{ required: true, message: 'Por favor selecciona la sesión!' }]}
                  >
                    <ClassDetails
                      formData={{}} // initial empty data
                      setFormData={(data) => form.setFieldsValue({ classDetails: data })}
                    />
                  </Form.Item>
                </div>
              </div>
            )}
            {payType === PayTypes.OTHER && (
              <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
                <CreditCardFilled className="icons" />
                <div className="w-75">
                  <Form.Item
                    name="item_id"
                    className="m-0"
                    rules={[{ required: true, message: 'Por favor selecciona una categoría' }]}
                  >
                    <SelectCategory className="w-100" />
                  </Form.Item>
                </div>
              </div>
            )}
          </div>
          <div className="input-group col-10 col-md-5 p-0 mx-auto justify-content-between mt-3">
            <Form.Item className='mx-auto my-3'>
              <Button type="primary" className='themed-btn' htmlType="submit">
                Registrar
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default CollectPayment;
